let module = angular.module('app.directives');

module.directive('uploadModalLauncher', ($uibModal) => {
  'ngInject';

  return {
    restrict: 'E',
    transclude: true,
    scope: {
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      modalHeading: '@',
      onUploaded: '&',
    },
    template: require('./upload-modal.html'),
    link: (scope) => {
      const { allowVideo, allowImage, slotName, modalHeading } = scope;

      scope.openUploadModal = () => {
        $uibModal
          .open({
            template: require('./upload-modal.html'),
            controller: UploadModalController,
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              params: () => {
                return {
                  slotName: slotName,
                  allowVideo: allowVideo,
                  allowImage: allowImage,
                  heading: modalHeading,
                  file: scope.uploadedFile,
                };
              },
            },
          })
          .result.then(() => {
            scope.onUploaded({ file: scope.uploadedFile });
          });
      };
    },
    template: `
    <a ng-click="openUploadModal()" class="class" style="style">
      <div ng-transclude></div>
    </a>
    `,
  };
});

function UploadModalController(params, $uibModalInstance) {
  this.params = params;

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.upload = () => {
    if (!this.file || !this.file.upload) {
      return;
    }
    this.uploading = true;
    this.file.upload().then((result) => {
      this.uploading = false;
      $uibModalInstance.close(result);
    });
  };
}



// WEBPACK FOOTER //
// ./app/directives/upload-modal-launcher.js